import { BIBLE_API } from 'config/constants';
import { IChapter, IVerse } from 'types';

import Fetch from '../fetch';

export const getChaptersByBookId = async (bookId: number): Promise<IChapter[]> => {
  const response = await Fetch.get(`${BIBLE_API}/chapters/${bookId}`, {
    isCache: true,
    cache: 'force-cache',
  });

  return response as IChapter[];
};

export const getChaptersByNumberAndBookIds = async (
  bookIds: number[],
  chapterNumber: number,
): Promise<IChapter[]> => {
  const response = await Fetch.get(
    `${BIBLE_API}/chapters/${bookIds.join(',')}/${chapterNumber}`,
    {
      isCache: true,
      cache: 'force-cache',
    },
  );

  return response as IChapter[];
};

export const getChaptersVerses = async (chapterIds: number[]): Promise<IVerse[]> => {
  const response = await Fetch.get(
    `${BIBLE_API}/verses/by-chapters?chapterIds=${chapterIds.join(',')}`,
    {
      isCache: true,
      cache: 'force-cache',
    },
  );

  return response as IVerse[];
};
